import React from 'react';
import Helmet from 'react-helmet';
import styles from './App.module.scss';

import favicon from './favicon/favicon.ico';
import appleTouchIcon57 from './favicon/apple-icon-57x57.png';
import appleTouchIcon60 from './favicon/apple-icon-60x60.png';
import appleTouchIcon72 from './favicon/apple-icon-72x72.png';
import appleTouchIcon76 from './favicon/apple-icon-76x76.png';
import appleTouchIcon114 from './favicon/apple-icon-114x114.png';
import appleTouchIcon120 from './favicon/apple-icon-120x120.png';
import appleTouchIcon144 from './favicon/apple-icon-144x144.png';
import appleTouchIcon152 from './favicon/apple-icon-152x152.png';
import appleTouchIcon180 from './favicon/apple-icon-180x180.png';
import andriodIcon192 from './favicon/android-icon-192x192.png';
import favicon32 from './favicon/favicon-32x32.png';
import favicon96 from './favicon/favicon-96x96.png';
import favicon16 from './favicon/favicon-16x16.png';
import msIcon144 from './favicon/ms-icon-144x144.png';
import ogimage from './favicon/og-image.png';

const Layout = ({ mainStyle, children, data, intl }) => {
  return (
    <div className={mainStyle ? mainStyle : styles.app}>
      <Helmet
        title="前端找工作"
        link={[
          { rel: 'shortcut icon', type: 'image/png', href: `${favicon}` },
          { rel: 'apple-touch-icon', sizes: '57x57', href: `${appleTouchIcon57}` },
          { rel: 'apple-touch-icon', sizes: '60x60', href: `${appleTouchIcon60}` },
          { rel: 'apple-touch-icon', sizes: '72x72', href: `${appleTouchIcon72}` },
          { rel: 'apple-touch-icon', sizes: '76x76', href: `${appleTouchIcon76}` },
          { rel: 'apple-touch-icon', sizes: '114x114', href: `${appleTouchIcon114}` },
          { rel: 'apple-touch-icon', sizes: '120x120', href: `${appleTouchIcon120}` },
          { rel: 'apple-touch-icon', sizes: '144x144', href: `${appleTouchIcon144}` },
          { rel: 'apple-touch-icon', sizes: '152x152', href: `${appleTouchIcon152}` },
          { rel: 'apple-touch-icon', sizes: '180x180', href: `${appleTouchIcon180}` },
          { rel: 'icon', type: 'image/png', sizes: '192x192', href: `${andriodIcon192}` },
          { rel: 'icon', type: 'image/png', sizes: '32x32', href: `${favicon32}` },
          { rel: 'icon', type: 'image/png', sizes: '96x96', href: `${favicon96}` },
          { rel: 'icon', type: 'image/png', sizes: '16x16', href: `${favicon16}` },
        ]}
        meta={[
          { name: 'msapplication-TileColor', content: '#2B3143' },
          { name: 'msapplication-TileImage', content: `${msIcon144}` },
          { name: 'theme-color', content: '#2B3143' },
          { name: 'google-site-verification', content: 'BOcbOmSPkSF8QMTgDeuyRGr_H8BmSby53bI5oOFvOUw' },
          { property: 'og:image', content: `https://f2efindjobs.patw.me${ogimage}` },
        ]}
      />

      {children}
    </div>
  );
};

export default Layout;



// WEBPACK FOOTER //
// ./src/components/layout.js